import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';

import UIModule from './ui/ui.module';
import SecurityModule from './security/security.module';

import EventDispatcherService from './event/eventdispatcher.service';
import AppService from './app.service';
import HTTPService from './http/http.service';
import StorageService from './storage.service';
import ChatService from './chat/chat.service';

import HTTPInterceptor from './http/http.interceptor';

import StandardLayoutComponent from './layout/standardlayout/standardlayout.component';

import ForbiddenPageComponent from './pages/forbidden.page';

import CustomerProductlistComponent from './system-components/customer-products-list.component';
import CustomerProductWidgetComponent from './system-components/customer-product-widget/customer-product-widget.component';
import MemberProductRequestModalComponent from './system-components/request-product/request-product.modal.component';
import MemberProductRequestSuccessModalComponent from './system-components/request-product/success.modal.component';
import SettingsModalComponent from './system-components/settings/settings.modal.component';
import LinkBankWidgetComponent from './system-components/link-bank-widget/link-bank-widget.component';
import ProductPasswordComponent from './system-components/product-password-widget/product-password-widget.component';
import AccountReminderWidget from './system-components/account-reminder-widget/account-reminder-widget.component';

import InputLlimitDirective from './directives/input-limit.directive.js';
import LoadingDirective from './directives/loading.directive.js';
import FileModelDirective from './directives/file-model.directive.js';

import AsyncFilter from './filters/async.filter';
import FilesizeFilter from './filters/filesize.filter';

let sharedModule = angular.module('app.shared', [
  ngCookies,
  UIModule,
  SecurityModule
])
.service('EventDispatcherService', EventDispatcherService)
.service('AppService', AppService)
.service('HttpService', HTTPService)
.service('StorageService', StorageService)
.service('ChatService', ChatService)
.component('customerProductsList', CustomerProductlistComponent)
.component('customerProductWidget', CustomerProductWidgetComponent)
.component('accountReminderWidget', AccountReminderWidget)
.component('linkBankWidget', LinkBankWidgetComponent)
.component('productPasswordWidget', ProductPasswordComponent)
.component('requestProductModal', MemberProductRequestModalComponent)
.component('requestProductSuccessModal', MemberProductRequestSuccessModalComponent)
.component('settingsModal', SettingsModalComponent)
.component('standardLayout', StandardLayoutComponent)
.component('forbiddenPage', ForbiddenPageComponent)
.directive('limit', InputLlimitDirective)
.directive('loading', LoadingDirective)
.directive('fileModel', FileModelDirective)
.filter('async', AsyncFilter)
.filter('filesize', FilesizeFilter)
.config(($httpProvider, $stateProvider) => {
  'ngInject';

  $httpProvider.interceptors.push(HTTPInterceptor);

  $stateProvider
  .state('standardLayout', {
    component: 'standardLayout'
  })
  .state('forbidden', {
    url: '/forbidden',
    component: 'forbiddenPage',
  })
  ;
})
.name;

export default sharedModule;



// WEBPACK FOOTER //
// ./client/app/shared/shared.module.js